import { render, staticRenderFns } from "./reminders.vue?vue&type=template&id=179bc7c8&scoped=true&"
import script from "./reminders.vue?vue&type=script&lang=js&"
export * from "./reminders.vue?vue&type=script&lang=js&"
import style0 from "./reminders.vue?vue&type=style&index=0&id=179bc7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179bc7c8",
  null
  
)

export default component.exports